import React from "react";
import { Row, Col, Glyphicon, OverlayTrigger, Tooltip } from "react-bootstrap";

const StartupsProductOverviewLayout = props => {
  const tooltip = (
    <Tooltip id="content-header-tooltip">
      Hier findest Du eine Übersicht Deiner angelegten Produktsorten.
    </Tooltip>
  );

  return (
    <div className="products">
      <Row>
        <Col md={10} mdPush={1}>
          <span className="content-header">Meine Produktsorten </span>
          <OverlayTrigger placement="right" overlay={tooltip}>
            <Glyphicon glyph="info-sign" />
          </OverlayTrigger>
        </Col>
      </Row>
      <br />
      {props.children}
    </div>
  );
};

export default StartupsProductOverviewLayout;
